import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = [ "fields", "toggle" ]

  toggle(event) {
    if(event.target.value == 'yes') {
      this.fieldsTarget.classList.remove('hidden');
    } else {
      this.fieldsTarget.classList.add('hidden');
    }
  }
}
